import {getPreference} from '@netx/core-user-next/utils/getPreference';

/**
 * Is bulk cart loader enabled
 * @method
 */
export const bulkCartLoaderEnabled = (v) => {
	return getPreference('cart.bulkCartLoader.enabled', true);
};
